import React, { useContext } from 'react';
import { StoreInfoReponse } from '../libs/nexo/actions';


const initialStore: StoreInfoReponse = {
  id: '',
  name: '',
  url: '',
  country: '',
  language: '',
  currency: ''
}

export interface StoreContextProps {
  store: StoreInfoReponse;
  setStore: React.Dispatch<React.SetStateAction<StoreInfoReponse>>;
}

const StoreContext = React.createContext<StoreContextProps>({} as StoreContextProps);

export function useStore(): StoreContextProps {
  return useContext(StoreContext);
}

interface StoreContextProviderProps {
  children: React.ReactNode;
}

function StoreContextProvider({
  children,
}: StoreContextProviderProps): JSX.Element {

  const [store, setStore] = React.useState<StoreInfoReponse>(initialStore);

  return (
    <StoreContext.Provider value={{ store, setStore }}>
      {children}
    </StoreContext.Provider>
  );
}

export default StoreContextProvider;
